import './styles.scss'
import React, { useEffect, useState, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { NoData } from 'Assets/Images'
import { getLocalLoggedInStatus, getLocalUserDetails } from 'Utils/LocalStorage_Handler'
import CustomDropdown from 'Components/CustomDropdown'
import { commonMethods } from 'Utils/commonMethods'
import { CoffeeWebContext } from 'Context/CoffeeWebContext'
import apiAdapterCoffeeWeb from 'Services/apiAdapter_CoffeeWeb'
import Brazil from './CountryWiseData/Brazil'
import Vietnam from './CountryWiseData/Vietnam'
import Uganda from './CountryWiseData/Uganda'
import Columbia from './CountryWiseData/Columbia'
import India from './CountryWiseData/India'

const CountryWiseExportsReport = ({ testingId }) => {
  const { t } = useTranslation()
  const { checkForUserAccess } = commonMethods
  const { setLoading } = useContext(CoffeeWebContext)

  const location = useLocation()
  const fullPath = location.pathname
  const pathSegments = fullPath.split('/')
  const desiredPath = pathSegments[2] || ''
  const isUserLoggedIn = getLocalLoggedInStatus()
  const userDetails = getLocalUserDetails()

  const [exportCountries, setExportCountries] = useState([])
  const [currentItem, setCurrentItem] = useState(null)
  const [noDataFound, setNoDataFound] = useState(false)
  const [swapReport, setSwapReport] = useState('Metric Tons')
  const [fileName, setFileName] = useState('')

  useEffect(() => {
    setSwapReport('Metric Tons')
  }, [currentItem])

  let menuLock

  if (userDetails && userDetails.menus) {
    const menu = userDetails.menus.find(({ menuUrl }) => menuUrl === desiredPath)

    if (menu) {
      menuLock = menu.menulock
    }
  }

  useEffect(() => {
    fetchExportCountries()
  }, [])

  const fetchExportCountries = async () => {
    try {
      const { data: countries } = await apiAdapterCoffeeWeb.getAllExportCountryData()
      const exportCountriesData = countries?.filter((item) => item?.iscofexportcountry)

      setExportCountries(exportCountriesData)
      setCurrentItem(exportCountriesData[0])
      setFileName(`${exportCountriesData[0]?.nicename?.toLowerCase()}.json`)
      setNoDataFound(false)
    } catch (error) {
      setNoDataFound(true)
    }
  }

  const toggleSwapOption = () => {
    setSwapReport((prevOption) => {
      if (prevOption === 'Metric Tons') return '60 KG Bags'
      if (prevOption === '60 KG Bags') return 'Millions Bags'

      return 'Metric Tons'
    })
  }

  const createMonthRange = (lastMonth) => {
    const monthAbbreviations = {
      January: 'Jan',
      February: 'Feb',
      March: 'Mar',
      April: 'Apr',
      May: 'May',
      June: 'Jun',
      July: 'Jul',
      August: 'Aug',
      September: 'Sept',
      October: 'Oct',
      November: 'Nov',
      December: 'Dec'
    }

    const month = lastMonth?.split(' ')[0]
    const year = lastMonth?.split(' ')[2]

    if (!month || !year || !monthAbbreviations[month]) {
      return 'Invalid month format'
    }

    const abbreviatedMonth = monthAbbreviations[month]

    return `Upto Jan - ${year} to ${abbreviatedMonth} - ${year}`
  }

  const countryComponents = {
    Brazil: <Brazil swapReport={swapReport} setLoading={setLoading} createMonthRange={createMonthRange} checkForUserAccess={checkForUserAccess} reportName={fileName} />,
    India: <India swapReport={swapReport} setLoading={setLoading} createMonthRange={createMonthRange} checkForUserAccess={checkForUserAccess} reportName={fileName} />,
    Vietnam: <Vietnam swapReport={swapReport} setLoading={setLoading} createMonthRange={createMonthRange} checkForUserAccess={checkForUserAccess} reportName={fileName} />,
    Colombia: <Columbia swapReport={swapReport} setLoading={setLoading} createMonthRange={createMonthRange} checkForUserAccess={checkForUserAccess} reportName={fileName} />,
    Uganda: <Uganda swapReport={swapReport} setLoading={setLoading} createMonthRange={createMonthRange} checkForUserAccess={checkForUserAccess} reportName={fileName} />
  }

  const handleCountryChange = (event) => {
    const chosenCountry = event.target.value

    setCurrentItem(chosenCountry)
    setFileName(`${chosenCountry?.nicename?.toLowerCase()}.json`)
  }

  return (
    <>
      <div className="country-wise-exports-container" data-testid={testingId}>
        <div className="header-section" data-testid="header-section-container">
          <div className="export-header" data-testid="export-header-container">
            <div className="dropdown-wrapper" data-testid="dropdown-wrapper-container">
              <CustomDropdown value={currentItem} options={exportCountries} optionLabel={'nicename'} placeholder={exportCountries?.length ? t('SELECT_COUNTRY') : t('NO_DATA_FOUND')} onChange={handleCountryChange} showFlags={true} className="country-selector" testId="country-wise-report-dropdown" />
            </div>

            <div className="report-title">{t('MONTH_WISE_REPORT')}</div>

            <div className="swap-icon-container" onClick={toggleSwapOption} data-testid="swap-icon-container">
              {swapReport}
              <div className="swap-icon" data-testid="icon-container">
                <i className="pi pi-angle-up upper-arrow" data-testid="upper-arrow-container" />
                <i className="pi pi-angle-down down-arrow" data-testid="down-arrow-container" />
              </div>
            </div>
          </div>
        </div>
        <div id="country-wise-export-report" data-testid="report-table">
          {currentItem && countryComponents[currentItem?.nicename]}
        </div>
        <div className="no-results-image-container">{noDataFound && <img src={NoData} alt="NoDataFound" className="no-results-found-image" />}</div>
      </div>
    </>
  )
}

export default CountryWiseExportsReport
